import { NavLink } from "react-router-dom";
import {  route } from "../../../../globals/constants";

function SectionBanner({ breadcrumb }) {

    return (
        <>
            <div className="mt-bnr-inr overlay-wraper" style={{ backgroundImage: `url(${breadcrumb?.image})` }}>
                <div className="overlay-main bg-black opacity-07" />
                <div className="container">
                    <div className="mt-bnr-inr-entry">
                        <h1 className="text-white">{breadcrumb?.description}</h1>
                       
                        <ul className="mt-breadcrumb breadcrumb-style-1">
                            <li><NavLink to={route.home.HOME1}>Home</NavLink></li>
                            <li>{breadcrumb?.description}</li>
                        </ul>
                    </div>
                </div>
            </div>

        </>
    )
}
export default SectionBanner;